import { useState, useEffect } from 'react';

// Hook personnalisé pour gérer la configuration
export const useConfig = () => {
  const [config, setConfig] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_API_URL}config/`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setConfig(data);
        setError(null);
      } catch (err) {
        console.error('Error fetching config:', err);
        setError(err.message);
        setConfig(null);
      }
    };

    fetchConfig();
  }, []);

  return { config, error };
};

// Fonction utilitaire pour récupérer une valeur par clé
export const getConfigValue = (config, key, defaultValue = null) => {
  if (!config || !Array.isArray(config)) {
    return defaultValue;
  }
  
  const item = config.find(item => item.key === key);
  return item ? item.value : defaultValue;
};

// Fonction pour convertir le tableau de config en objet
export const configArrayToObject = (configArray) => {
  if (!configArray || !Array.isArray(configArray)) {
    return {};
  }
  
  return configArray.reduce((acc, item) => {
    if (item.key && item.value !== undefined) {
      acc[item.key] = item.value;
    }
    return acc;
  }, {});
};

// Fonction standalone pour charger la config (sans hooks)
export const fetchConfig = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_API_URL}config/`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error fetching config:', error);
    throw error;
  }
};